const features = [
  {
    icon: 'ri-database-2-line',
    title: 'Smart Data Organization',
    description:
      'Effortlessly structure and categorize your data with intelligent sorting, filtering, and grouping capabilities built into VigorBuy Spreadsheet.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Advanced Spreadsheet Management',
    description:
      'Take full control of your spreadsheets with powerful management tools, version tracking, and collaborative editing features.',
  },
  {
    icon: 'ri-flow-chart',
    title: 'Easy Workflow Optimization',
    description:
      'Streamline your daily tasks with automated workflows, custom formulas, and batch processing that save hours of manual work.',
  },
  {
    icon: 'ri-file-copy-2-line',
    title: 'Professional Templates',
    description:
      'Access a rich library of pre-built templates for budgeting, inventory, project management, and more — ready to customize instantly.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Business Reporting',
    description:
      'Generate comprehensive reports with visual charts, pivot tables, and data summaries that make insights clear and actionable.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Productivity Improvement',
    description:
      'Boost your team productivity with real-time collaboration, keyboard shortcuts, and seamless integration with your favorite tools.',
  },
];

export default function FeatureSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-sparkling-line"></i>
            Key Benefits
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            Why Choose VigorBuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            VigorBuy Spreadsheet combines powerful features with intuitive design to help you
            work smarter and achieve more with your data.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/60">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
            {[
              { value: '60+', label: 'Expert Guides' },
              { value: '14', label: 'Product Categories' },
              { value: '100%', label: 'Free Resources' },
              { value: '24/7', label: 'Updated Content' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="font-heading text-2xl md:text-3xl text-primary-600 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-600 whitespace-nowrap">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}